<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img
        src="https://resource.3uplay.com/sys-feed/c36791b2-6d2f-4774-a432-993cdc56bb5e5554735552447613343.webp"
        alt=""
        class="portrait1"
      />
      <img
        src="https://resource.3uplay.com/sys-feed/4f62850a-9a3b-4dc7-9bd9-dca017d7aec17689069356443557573.webp"
        alt=""
        class="portrait2"
      />
      <img
        src="https://resource.3uplay.com/sys-feed/9d0c1631-e13e-4bcd-8581-2e58d5019e651927828689014986420.webp"
        alt=""
        class="portrait3"
      />
      <div class="tab-box">
        <img
          src="./images/tab1.png"
          alt=""
          v-show="activeTabIndex != 0"
          @click="checkTab(0)"
        />
        <img
          src="./images/tab1-active.png"
          alt=""
          v-show="activeTabIndex === 0"
          @click="checkTab(0)"
        />
        <img
          src="./images/tab2.png"
          alt=""
          v-show="activeTabIndex != 1"
          @click="checkTab(1)"
        />
        <img
          src="./images/tab2-active.png"
          alt=""
          v-show="activeTabIndex == 1"
          @click="checkTab(1)"
        />
        <img
          src="./images/tab3.png"
          alt=""
          v-show="activeTabIndex != 2"
          @click="checkTab(2)"
        />
        <img
          src="./images/tab3-active.png"
          alt=""
          v-show="activeTabIndex == 2"
          @click="checkTab(2)"
        />
      </div>
      <div class="score-box">
        <div class="score-box1">
          <div
            class="item"
            v-for="(item, index) of list.slice(0, 3)"
            :key="index"
          >
            <div class="left">
              <img
                :src="item.avatar"
                alt=""
                @click="toPlayerDetail(item.uuid)"
              />
              <span class="user-name">{{ item.nickname }}</span>
            </div>
            <div class="right">
              <span>搗蛋值</span>
              <span class="score">{{ Math.trunc(item.total) }}</span>
            </div>
          </div>
        </div>
        <div class="score-box2">
          <div class="item" v-for="(item, index) of list.slice(3)" :key="index">
            <div class="left">
              <span class="index">{{ index + 4 }}</span>
              <img
                :src="item.avatar"
                alt=""
                @click="toPlayerDetail(item.uuid)"
              />
              <span class="user-name">{{ item.nickname }}</span>
            </div>
            <div class="right">
              <span>搗蛋值</span>
              <span class="score">{{ Math.trunc(item.total) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="my-score">
        {{ scoreText }}：&nbsp;&nbsp;{{ Math.trunc(score) }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActivityBox',
  data() {
    return {
      listData: undefined,
      myScore: {
        shouli: 0,
        songli: 0,
        xiadan: 0
      },
      activeTabIndex: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    list() {
      if (this.listData) {
        return this.activeTabIndex === 0
          ? this.listData['songli']
          : this.activeTabIndex === 1
          ? this.listData['shouli']
          : this.listData['xiadan'];
      } else {
        return [];
      }
    },
    score() {
      try {
        return this.activeTabIndex === 0
          ? this.myScore['songli'][0].total
          : this.activeTabIndex === 1
          ? this.myScore['shouli'][0].total
          : this.myScore['xiadan'][0].total;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    scoreText() {
      return this.activeTabIndex === 0
        ? '我的送禮搗蛋值'
        : this.activeTabIndex === 1
        ? '我的收禮搗蛋值'
        : '我的下單搗蛋值';
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore(val);
        } else {
          this.myScore = {
            shouli: 0,
            songli: 0,
            xiadan: 0
          };
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getList() {
      try {
        const url = 'https://devops.nicee.app/api/huodong/wanshengjie/daodan';
        const res = await this.$http.get(url);
        console.log(res);
        this.listData = res;
      } catch (error) {
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    async getMyscore(uuid) {
      try {
        const url = `https://devops.nicee.app/api/huodong/wanshengjie/daodan/${uuid}`;
        const res = await this.$http.get(url);
        if (res) {
          this.myScore = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    checkTab(index) {
      this.activeTabIndex = index;
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
@function doublePx($value) {
  @return $value * 2;
}
.activity-box {
  width: 100%;
  background-color: #2c1968;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .portrait1,
    .portrait2,
    .portrait3 {
      position: absolute;
      top: 1584.51px;
      height: auto;
      width: 230px;
    }
    .portrait1 {
      left: 122px;
    }
    .portrait2 {
      left: 374.88px;
    }
    .portrait3 {
      left: 627.73px;
    }
    .score-box {
      position: absolute;
      top: 4333px;
      left: 52px;
      overflow: auto;
      height: 700px;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .score-box1 {
      background-image: url('./images/score-bg.png');
      background-size: 100% auto;
      background-repeat: no-repeat;
      width: 860px;
      height: 500px;
      .item {
        &:last-child{
          margin-bottom: 40px;
        }
      }
    }
    .score-box1,
    .score-box2 {
      font-size: 31px;
      font-weight: 600;
      color: white;
      .item {
        height: 128px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 51px;
        width: 836px;
        padding-left: 140px;
        padding-right: 40px;
        .left {
          display: flex;
          align-items: center;
          width: 1px;
          flex: auto;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .right {
          white-space: nowrap;
          min-width: 180px;
        }
        .score {
          display: inline-block;
        }

        img {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 50%;
          border: 3px solid white;
          z-index: 1;
          position: relative;
          background-color: white;
          margin-right: 20px;
        }
        .user-name {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .score-box2 {
      .item {
        padding-left: 46px;
        margin-bottom: 2px;
        .index {
          display: inline-block;
          margin-right: 73px;
        }
      }
    }
    .my-score {
      position: absolute;
      top: 5071px;
      width: 712px;
      height: 91px;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 50%;
      transform: translateX(-50%);
      font-size: 42px;
      font-weight: bold;
      color: white;
    }
    .tab-box {
      position: absolute;
      top: 4160px;
      left: 75px;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 263px;
        height: auto;
        margin-right: 16px;
      }
    }
  }
}
</style>
